var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeoffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -133.653 596.312 779.709",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 10.199,
    y: 180.261,
    style: {
      fill: "#E8E8E8"
    },
    width: 328.231,
    height: 318.582
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F07057"
    },
    points: "175.251,13.158 10.199,180.258 338.428,180.258 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.701,
    y: 322.07,
    style: {
      fill: "#84B3D2"
    },
    width: 121.218,
    height: 176.773
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.43,
    y: 270.105,
    style: {
      fill: "#E8E8E8"
    },
    width: 163.371,
    height: 228.738
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.43,
    y: 180.261,
    style: {
      fill: "#F07057"
    },
    width: 163.371,
    height: 89.845
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.323,336.489c-5.632,0-10.199,4.567-10.199,10.199v9.068c0,5.632,4.567,10.199,10.199,10.199s10.199-4.567,10.199-10.199 v-9.068C53.522,341.056,48.955,336.489,43.323,336.489z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.323,382.84c-5.632,0-10.199,4.567-10.199,10.199v74.565c0,5.632,4.567,10.199,10.199,10.199s10.199-4.567,10.199-10.199 V393.04C53.522,387.408,48.955,382.84,43.323,382.84z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512,180.258c0-5.632-4.567-10.199-10.199-10.199H342.723L182.547,6.032c-1.912-1.958-4.53-3.066-7.268-3.074 c-0.01,0-0.019,0-0.029,0c-2.726,0-5.339,1.091-7.256,3.032l-67.391,68.228V39.609c0-5.632-4.567-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199V94.87L2.943,173.091c-0.006,0.006-0.006,0.011-0.011,0.017C1.12,174.949,0,177.471,0,180.258v318.585 c0,5.632,4.567,10.199,10.199,10.199h491.602c5.632,0,10.199-4.567,10.199-10.199V180.258z M491.602,259.907H348.626v-69.45h142.976 V259.907z M175.209,27.713l139.003,142.345H34.609L175.209,27.713z M328.228,488.644H245.12V322.07 c0-5.632-4.567-10.199-10.199-10.199H113.706c-5.632,0-10.199,4.567-10.199,10.199v166.573H20.398V190.457h307.829V488.644z M123.905,488.644V332.27h100.817v156.374H123.905z M491.602,488.644H348.626V280.306h142.976V488.644z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -421.977112, -433.755066)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718.937,
    y: 440.923,
    style: {
      fill: "#E8E8E8"
    },
    width: 266.75,
    height: 491.602
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.593,
    y: 53.636,
    style: {
      fill: "#F07057"
    },
    width: 63.368,
    height: 63.368
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.039,
    y: 53.636,
    style: {
      fill: "#F07057"
    },
    width: 63.368,
    height: 63.368
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.593,
    y: 166.063,
    style: {
      fill: "#F07057"
    },
    width: 63.368,
    height: 63.368
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.039,
    y: 166.063,
    style: {
      fill: "#F07057"
    },
    width: 63.368,
    height: 63.368
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.593,
    y: 278.489,
    style: {
      fill: "#F07057"
    },
    width: 63.368,
    height: 63.368
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.039,
    y: 278.489,
    style: {
      fill: "#F07057"
    },
    width: 63.368,
    height: 63.368
  })), /*#__PURE__*/React.createElement("rect", {
    x: 800.184,
    y: 826.749,
    style: {
      fill: "#84B3D2"
    },
    width: 104.246,
    height: 105.786
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 985.688 942.724 C 991.32 942.724 995.887 938.158 995.887 932.525 L 995.887 440.923 C 995.887 435.29 991.32 430.724 985.688 430.724 L 718.936 430.724 C 713.304 430.724 708.737 435.29 708.737 440.923 L 708.737 932.525 C 708.737 938.158 713.304 942.724 718.936 942.724 L 985.688 942.724 Z M 862.511 922.326 L 862.511 891.133 C 862.511 885.5 857.944 880.934 852.312 880.934 C 846.68 880.934 842.113 885.5 842.113 891.133 L 842.113 922.326 L 810.387 922.326 L 810.387 836.943 L 894.238 836.943 L 894.238 922.326 L 862.511 922.326 Z M 975.489 922.326 L 914.635 922.326 L 914.635 826.744 C 914.635 821.111 910.068 816.545 904.436 816.545 L 800.188 816.545 C 794.556 816.545 789.989 821.111 789.989 826.744 L 789.989 922.326 L 729.135 922.326 L 729.135 451.122 L 975.49 451.122 L 975.49 922.325 L 975.489 922.325 L 975.489 922.326 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 763.905 557.925 L 827.272 557.925 C 832.904 557.925 837.471 553.359 837.471 547.726 L 837.471 484.36 C 837.471 478.727 832.904 474.161 827.272 474.161 L 763.905 474.161 C 758.273 474.161 753.706 478.727 753.706 484.36 L 753.706 547.727 C 753.706 553.359 758.273 557.925 763.905 557.925 Z M 774.105 494.559 L 817.073 494.559 L 817.073 537.527 L 774.105 537.527 L 774.105 494.559 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 877.352 557.925 L 940.719 557.925 C 946.351 557.925 950.918 553.359 950.918 547.726 L 950.918 484.36 C 950.918 478.727 946.351 474.161 940.719 474.161 L 877.352 474.161 C 871.72 474.161 867.153 478.727 867.153 484.36 L 867.153 547.727 C 867.153 553.359 871.719 557.925 877.352 557.925 Z M 887.551 494.559 L 930.519 494.559 L 930.519 537.527 L 887.551 537.527 L 887.551 494.559 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 763.905 670.35 L 827.272 670.35 C 832.904 670.35 837.471 665.784 837.471 660.151 L 837.471 596.784 C 837.471 591.151 832.904 586.585 827.272 586.585 L 763.905 586.585 C 758.273 586.585 753.706 591.151 753.706 596.784 L 753.706 660.151 C 753.706 665.784 758.273 670.35 763.905 670.35 Z M 774.105 606.984 L 817.073 606.984 L 817.073 649.952 L 774.105 649.952 L 774.105 606.984 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 877.352 670.35 L 940.719 670.35 C 946.351 670.35 950.918 665.784 950.918 660.151 L 950.918 596.784 C 950.918 591.151 946.351 586.585 940.719 586.585 L 877.352 586.585 C 871.72 586.585 867.153 591.151 867.153 596.784 L 867.153 660.151 C 867.153 665.784 871.719 670.35 877.352 670.35 Z M 887.551 606.984 L 930.519 606.984 L 930.519 649.952 L 887.551 649.952 L 887.551 606.984 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 763.905 782.775 L 827.272 782.775 C 832.904 782.775 837.471 778.209 837.471 772.576 L 837.471 709.209 C 837.471 703.576 832.904 699.01 827.272 699.01 L 763.905 699.01 C 758.273 699.01 753.706 703.576 753.706 709.209 L 753.706 772.576 C 753.706 778.209 758.273 782.775 763.905 782.775 Z M 774.105 719.408 L 817.073 719.408 L 817.073 762.376 L 774.105 762.376 L 774.105 719.408 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 877.352 782.775 L 940.719 782.775 C 946.351 782.775 950.918 778.209 950.918 772.576 L 950.918 709.209 C 950.918 703.576 946.351 699.01 940.719 699.01 L 877.352 699.01 C 871.72 699.01 867.153 703.576 867.153 709.209 L 867.153 772.576 C 867.153 778.209 871.719 782.775 877.352 782.775 Z M 887.551 719.408 L 930.519 719.408 L 930.519 762.376 L 887.551 762.376 L 887.551 719.408 Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 852.312 849.25 C 846.68 849.25 842.113 853.816 842.113 859.449 L 842.113 860.471 C 842.113 866.104 846.68 870.67 852.312 870.67 C 857.944 870.67 862.511 866.104 862.511 860.471 L 862.511 859.449 C 862.511 853.817 857.944 849.25 852.312 849.25 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 596.312378, 430.724426)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 296.773 -133.653 L 295.334 646.056 L 296.773 -133.653 Z",
    style: {
      strokeLinecap: "round",
      paintOrder: "fill markers",
      strokeMiterlimit: 1,
      strokeWidth: 27,
      strokeDasharray: "20, 60",
      stroke: "rgb(240, 112, 88)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeoffice);
export default __webpack_public_path__ + "static/media/homeoffice.3319b155acf93766ef8458c9ad7c77d8.svg";
export { ForwardRef as ReactComponent };